import React from 'react';
import { Link } from 'react-router-dom';
import Button from '@material-ui/core/Button';
import { CORES } from '../../theme';

/**
 * Exibida quando a rota não existe ou o usuário não tem permissão.
 * Antes a tela ficava em branco, o que parecia erro do sistema.
 */
const NaoEncontrado = () => (
    <div style={{ maxWidth: 480, margin: '80px auto', textAlign: 'center', color: CORES.texto }}>
        <h1 style={{ marginBottom: 8 }}>Página não disponível</h1>
        <p style={{ color: CORES.textoSuave, marginBottom: 24 }}>
            Esta página não existe ou você não tem permissão para acessá-la.
            Se acha que deveria ter acesso, fale com o administrador do CRM.
        </p>
        <Button component={Link} to="/home" variant="contained" color="primary">
            Voltar para o início
        </Button>
    </div>
);

export default NaoEncontrado;
